import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  holder: {
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  },

  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
    border: ({ selected }) => (selected ? 'none' : '1px solid #f0f0f0'),
    borderRadius: '100rem',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: '0.25rem 7px',
    backgroundColor: ({ selected }) =>
      selected ? 'rgb(240, 248, 255)' : 'white',
    cursor: 'pointer',

    [theme.breakpoints.down(340)]: {
      width: 'calc(100% - 1.5rem)'
    }
  },

  avatarArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.5rem',
    minWidth: '50px',
    height: 'auto',

    '& > div': {
      height: '55px'
    }
  },

  avatar: {
    border: '2px solid white',
    width: '30px',
    height: '30px',
    fontSize: theme.size.sm
  },

  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },

  name: {
    margin: '0 11px',
    width: '100%',
    maxWidth: 'calc(100% - 9rem)',
    fontSize: theme.size.sm,
    color: '#7F8487',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',

    [theme.breakpoints.up(1300)]: {
      maxWidth: '9rem'
    }
  }
}))

export default useStyles
